import { ExclamationCircleOutlined, SwapOutlined } from "@ant-design/icons";
import { Button, Divider, Modal, Popconfirm } from "antd";
import React, { useState } from "react";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";

const dienstOvergenomen = (name) => {
  Modal.success({
    title: $t("Dienst overgenomen"),
    content: name
      ? $t(
          "De dienst is overgenomen en ${name} heeft een mail ontvangen ter bevestiging.",
          { name }
        )
      : $t("Dank je wel voor het invullen van deze dienst."),
  });
};

const DienstRow = ({
  dienst,
  user,
  openAanmelding,
}) => {
  const [loading, setLoading] = useState(false);
  const [swapped, setSwapped] = useState(false);

  const neem_over = async () => {
    setLoading(true);
    const res = await api.post("rooster/neem_dienst_over.json", {
      dienst_id: dienst.id,
    });
    if (res) {
      dienstOvergenomen(dienst.user_name);
      setSwapped(true);
      openAanmelding();
    }

    setLoading(false);
  };

  let isAangemeld = dienst?.signed_in

  let magOvernemen = dienst?.groups?.some(g => user?.group_keys?.includes(g));

  return (
    <div>
      <div className="row" style={{ gap: 12, marginTop: 6 }}>
        <div>
          <p className="small">{dienst.name}</p>
          <p
            className={!isAangemeld || !dienst.user_name ? "bold alert" : ""}
            style={{ marginRight: 4 }}
          >
            {!isAangemeld && (
              <ExclamationCircleOutlined style={{ marginRight: 6 }} />
            )}
            {swapped ? user.name : dienst.user_name ? dienst.user_name : $t("OPEN")}
          </p>
        </div>

        {user && (
          <p style={{ lineHeight: "14px" }}>
            {!swapped &&
              dienst.user_id !== user.id &&
              magOvernemen && (
                <Popconfirm
                  placement="bottom"
                  title={$t("Zeker weten dat je deze dienst wilt overnemen?")}
                  onConfirm={() => neem_over()}
                  okText={$t("Ja")}
                  cancelText={$t("Nee")}
                >
                  <Button
                    size="small"
                    icon={<SwapOutlined />}
                    loading={loading}
                    shape="circle"
                  />
                </Popconfirm>
              )}
          </p>
        )}
      </div>

      <Divider style={{ margin: "2px 0" }} />
    </div>
  );
};

export const CardRooster = ({
  diensten,
  user,
  openAanmelding,
}) =>
  diensten.map((dienst, key) => (
    <DienstRow
      key={key}
      dienst={dienst}
      user={user}
      openAanmelding={openAanmelding}
    />
  ));
